import { useContext } from 'react';

import { ChannelsContext } from './ChannelsProvider';
import { ChannelsContextValues } from './types';

export function useChannels() {
  return useContext<ChannelsContextValues>(ChannelsContext);
}
